export default __webpack_public_path__ + "static/wheel-afd305e5a4289c48da702e39064d4a19.svg";